import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'
import { WagmiProvider } from 'wagmi';
import { config } from './config/wagmi';
import { WalletProvider } from './contexts/WalletContext';
import { SolanaWalletProvider } from './providers/SolanaWalletProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <SolanaWalletProvider>
          <WalletProvider>
            {(navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i))
              ?
              <DndProvider backend={TouchBackend}>
                <App />
              </DndProvider>
              :
              <DndProvider backend={HTML5Backend}>
                <App />
              </DndProvider>
            }
          </WalletProvider>
        </SolanaWalletProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);

// Register PWA Service Worker for installability
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Only register in production or if running on actual domain
    const isProduction = import.meta.env.MODE === 'production';
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    if (isProduction || !isLocalhost) {
      navigator.serviceWorker.register('/sw.js')
        .then(registration => {
          console.log('PWA Service Worker registered:', registration.scope);
        })
        .catch(err => {
          console.log('PWA Service Worker registration failed:', err);
        });
    } else {
      console.log('PWA Service Worker skipped in local development');
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
